import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QnSbnSideNavigationComponent } from './qn-sbn-side-navigation/qn-sbn-side-navigation.component';

@Component({
  selector: 'dl-create-notification',
  templateUrl: './create-notification.component.html',
  styleUrls: ['./create-notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateNotificationComponent implements OnInit, OnDestroy {
  public constructor(private router: Router, private activatedRoute: ActivatedRoute, private renderer: Renderer2) {
    this.renderer.addClass(document.body, 'local-notification-config');
  }
  public routerConfig = this.router.config.find(item => item.path === 'create-notification');
  public childPathArray = this.routerConfig && this.routerConfig.children.map(item => item.path);

  public btnCurrentState = {
    isPrevDisabled: true,
    isNextDisabled: false
  };

  @ViewChild(QnSbnSideNavigationComponent) QnSbnSideNavigationComponent: QnSbnSideNavigationComponent;


  public ngOnInit(): void {
    this.setButtonDisabled();
  }

  public ngOnDestroy() {
    this.renderer.removeClass(document.body, 'local-notification-config');
  }

  public getCurrentPathIndex(): number {
    const currentNavItem = this.router.routerState.snapshot.url.split('/').pop();
    return this.childPathArray && this.childPathArray.findIndex(x => x === currentNavItem);
  }

  public setButtonDisabled(): void {
    const urlIndex = this.getCurrentPathIndex();
    if (urlIndex === 1) {
      this.btnCurrentState = {
        isPrevDisabled: true,
        isNextDisabled: false
      };
    } else if (urlIndex === (this.childPathArray && this.childPathArray.length - 1)) {
      this.btnCurrentState = {
        isPrevDisabled: false,
        isNextDisabled: true
      };
    } else {
      this.btnCurrentState = {
        isPrevDisabled: false,
        isNextDisabled: false
      };
    }
  }

  public onCloseBtnClicked(newVal: boolean): void {
    const resetState = {
      isPrevDisabled: newVal,
      isNextDisabled: false
    };
    this.btnCurrentState = resetState;
  }

  public onSideNavItemClicked(data: BtnStateData): void {
    const resetState = {
      isPrevDisabled: data.isPrevState,
      isNextDisabled: data.isNextState
    };
    this.btnCurrentState = resetState;
    this.QnSbnSideNavigationComponent.asterixValidation();
  }

  public onPrevNextBtnClicked(data: BtnStateData): void {
    const resetState = {
      isPrevDisabled: data.isPrevState,
      isNextDisabled: data.isNextState
    };
    this.btnCurrentState = resetState;
    this.QnSbnSideNavigationComponent.asterixValidation();
  }
}

export interface BtnStateData {
  isPrevState: boolean;
  isNextState: boolean;
}
